import { render, staticRenderFns } from "./AdminEventMenu.vue?vue&type=template&id=84266bee&scoped=true"
import script from "./AdminEventMenu.vue?vue&type=script&lang=js"
export * from "./AdminEventMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminEventMenu.vue?vue&type=style&index=0&id=84266bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84266bee",
  null
  
)

export default component.exports